import { useCallback, useEffect } from 'react';
import { useGetEventSchemaDetails } from '@ion/api';
import { saveFile } from '@ion/components';
import { isEmpty } from 'lodash';
import useProcessItems from 'app/shared/hooks/useProcessItems';
import todayDateString from 'app/shared/helpers/todayDateString';
import fetchAllSchemas from './fetchAllSchemas';

export default function useBulkExport({ open, onClose, cluster, earliestSeen, reports }) {
  const process = useProcessItems();
  const [getSchemaDetails] = useGetEventSchemaDetails();

  const totalCount = isEmpty(reports) ? 0 : reports.length;

  const startExport = useCallback(async () => {
    if (isEmpty(reports)) return;

    process.beginProcessing();

    try {
      const schemaFiles = await fetchAllSchemas({
        reports,
        cluster,
        earliestSeen,
        getSchemaDetails,
        onProgress: process.setCurrentIndex,
        shouldCancel: process.shouldCancel,
      });

      if (schemaFiles) {
        saveFile({ compressFile: true, content: schemaFiles, filename: `event-schemas-${todayDateString()}` });
        process.complete();
      } else {
        process.reset();
      }
    } catch (err) {
      process.fail(err.message);
    }
  }, [reports, cluster, earliestSeen, getSchemaDetails]); // eslint-disable-line react-hooks/exhaustive-deps

  const closeIfNotProcessing = useCallback(() => {
    if (!process.isProcessing) {
      onClose();
    }
  }, [process.isProcessing, onClose]);

  useEffect(() => {
    if (open) {
      startExport();
    } else {
      process.reset();
    }
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  return { process, totalCount, closeIfNotProcessing };
}
